import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-search-01",
  "use": "icon-search-01-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-search-01\">\r\n  <defs>\r\n    <style>\r\n      #icon-search-01 .cls-1 {\r\n        fill: #fff;\r\n      }\r\n    </style>\r\n  </defs>\r\n  <path id=\"icon-search-01_l_706\" data-name=\"l 706\" class=\"cls-1\" d=\"M23.712,22.189l-5.364-5.361a10.236,10.236,0,1,0-1.512,1.523L22.2,23.712a.971.971,0,0,0,1.38,0l.132-.132a.984.984,0,0,0,0-1.391ZM2.136,10.327a8.2,8.2,0,1,1,8.2,8.192,8.2,8.2,0,0,1-8.2-8.192Z\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol